module.exports = __webpack_public_path__ + "static/media/noti.cb8e23a6.svg";